import React, { useContext } from 'react';
import { CustomizedTypography } from '@components/Customized';
import { useStyles } from './styles';
import {
  Box,
  Collapse,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Switch
} from '@material-ui/core';

import clsx from 'clsx';
import { CapaQuotationUserNotificationFilterInput } from '@generated/graphql';
import { MyAccountContext } from '@routes/MyAccount/MyAccountContainer';
import { Data, DataSet, Kind } from './types';
import {
  Bullhorn,
  Chat,
  NotificationOff,
  WarningFilled
} from '@carbon/icons-react';
import { ResultNew } from '@assets';
interface Props {
  onSubmit: (data: CapaQuotationUserNotificationFilterInput) => void;
  matches: boolean;
}
export default function NotificationPresenter({ onSubmit, matches }: Props) {
  const classes = useStyles();

  const hoursOfADay = 24;
  const noon = 12;
  const startHours = 18;

  const handleStartTimeChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const idx = event.target.value as number;

    const data = setDoNotDisturb('from', idx === 0 ? hoursOfADay : idx);

    onSubmitHandle('doNotDisturb', data);
  };

  const handleEndTimeChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const idx = event.target.value as number;

    const data = setDoNotDisturb('to', idx === 0 ? hoursOfADay : idx);

    onSubmitHandle('doNotDisturb', data);
  };

  const context = useContext(MyAccountContext);

  const { data } = context;

  if (!data?.notificationFilter) return null;

  const { notificationFilter } = data;
  const {
    chatSMS,
    chatEmail,
    newsEmail,
    newsSMS,
    projectEmail,
    projectSMS
  } = notificationFilter;

  const doNotDisturb = {
    isActive: notificationFilter.doNotDisturb?.isActive,
    from: notificationFilter.doNotDisturb?.from,
    to: notificationFilter.doNotDisturb?.to
  };

  const HourList = (IsEndTimeSelectItem: boolean) => {
    let li = [];

    for (let i = startHours; i < startHours + hoursOfADay; i++) {
      let hour = i % hoursOfADay;

      const value = hour === 0 ? hoursOfADay : hour;

      li.push(
        <MenuItem
          value={value}
          key={value}
          disabled={
            IsEndTimeSelectItem
              ? doNotDisturb.from === value
                ? true
                : false
              : doNotDisturb.to === value
              ? true
              : false
          }
        >
          {hour < noon ? '오전' : '오후'}{' '}
          {hour === 0 ? noon : hour > noon ? hour - noon : hour}시
        </MenuItem>
      );
    }
    return li;
  };
  const projectFilters =
    notificationFilter.projectFilters?.map((v) => {
      delete v.__typename;
      return v;
    }) ?? [];

  // const projectServices = Object.keys(ProjectFiltersTitle) as Array<
  //   ProjectFiltersServiceType
  // >;

  const projectEmailChecked =
    projectEmail ?? projectFilters?.some((item) => item.email);
  const projectSmsChecked =
    projectSMS ?? projectFilters?.some((item) => item.sms);
  const projectChannelsNotChecked = !projectSmsChecked && !projectEmailChecked;

  // const setProjectByService = (
  //   service: ProjectFiltersServiceType,
  //   data: boolean | Array<string>
  // ) => {
  //   const newProjectFilters = projectFilters.map((item) => {
  //     const originalData = {
  //       email: item.email,
  //       sms: item.sms,
  //       service: item.service
  //     };
  //     return item.service === service
  //       ? {
  //           email:
  //             projectEmailChecked || projectChannelsNotChecked
  //               ? (data as boolean)
  //               : item.email,
  //           sms:
  //             projectSmsChecked || projectChannelsNotChecked
  //               ? (data as boolean)
  //               : item.sms,
  //           service: item.service
  //         }
  //       : originalData;
  //   });
  //   return newProjectFilters;
  // };

  const setProjectByChannel = (
    channel: 'Email' | 'SMS',
    data: boolean | Array<string>
  ) => {
    const newProjectFilters = projectFilters.map((item) => {
      return {
        email:
          channel === 'Email' &&
          (projectChannelsNotChecked || projectEmailChecked || item.sms)
            ? (data as boolean)
            : item.email,
        sms:
          channel === 'SMS' &&
          (projectChannelsNotChecked || projectSmsChecked || item.email)
            ? (data as boolean)
            : item.sms,
        service: item.service
      };
    });
    return newProjectFilters;
  };

  const setDoNotDisturb = (
    kind: 'isActive' | 'from' | 'to',
    data: boolean | number
  ) => {
    return {
      isActive:
        kind === 'isActive' ? (data as boolean) : doNotDisturb?.isActive,
      from: kind === 'from' ? (data as number) : doNotDisturb?.from,
      to: kind === 'to' ? (data as number) : doNotDisturb?.to
    };
  };

  const onSubmitHandle = (kind: Kind, data: Data) => {
    if (data === undefined) return;
    const req = {
      ...{
        doNotDisturb,
        projectFilters,
        projectEmail,
        projectSMS,
        chatEmail,
        chatSMS,
        newsEmail,
        newsSMS
      },
      [kind]: data
    };

    onSubmit(req);
  };

  const onSubmitHandleAsArray = (arr: Array<DataSet>) => {
    let newData = {
      doNotDisturb,
      projectFilters,
      projectEmail,
      projectSMS,
      chatEmail,
      chatSMS,
      newsEmail,
      newsSMS
    };

    const completed = arr.every((item) => {
      if (item.data === undefined) return false;
      newData = {
        ...newData,
        [item.kind]: item.data
      };
      return true;
    });

    if (completed) {
      onSubmit(newData);
    }
  };

  return (
    <Grid container direction="column" className={classes.root}>
      <Grid item>
        {!matches && (
          <CustomizedTypography className={classes.mainTitle}>
            알림설정
          </CustomizedTypography>
        )}
        {/* <CustomizedTypography className={classes.subTitle}>
          받고싶은 알림 유형 및 채널을 선택할 수 있어요.
        </CustomizedTypography> */}
      </Grid>
      <Grid item>
        <Box className={clsx(classes.box, 'doNotDisturb')}>
          <Box className={classes.titleBox}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Grid container direction="row" alignItems="center">
                  <NotificationOff size={21} />
                  <CustomizedTypography className={classes.boxMainTitle}>
                    방해금지시간 설정
                  </CustomizedTypography>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="row" alignItems="center">
                  <CustomizedTypography
                    className={clsx(classes.switchStateTitle, {
                      on: doNotDisturb?.isActive
                    })}
                  >
                    {doNotDisturb?.isActive ? '켜짐' : '꺼짐'}
                  </CustomizedTypography>
                  <Switch
                    color="primary"
                    checked={!!doNotDisturb?.isActive}
                    onChange={(e) => {
                      onSubmitHandle(
                        'doNotDisturb',
                        setDoNotDisturb('isActive', e.target.checked)
                      );
                    }}
                    className={clsx(classes.switch, {
                      off: !doNotDisturb?.isActive
                    })}
                    name="doNotDisturb"
                  ></Switch>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Collapse in={!!doNotDisturb?.isActive}>
            <Divider className={classes.titleDivider} />
            <Box className={classes.doNotDisturbBox}>
              {!matches ? (
                <Grid container direction="row" alignItems="center">
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <Select
                          displayEmpty
                          value={doNotDisturb?.from}
                          onChange={handleStartTimeChange}
                          MenuProps={{
                            classes: { paper: classes.menuPaper }
                          }}
                          className={classes.select}
                        >
                          <MenuItem value="" disabled>
                            시작 시간
                          </MenuItem>
                          {HourList(false)}
                        </Select>
                      </FormControl>
                      <CustomizedTypography
                        className={classes.selectSubText}
                        color="textPrimary"
                      >
                        부터
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                  <CustomizedTypography
                    className={classes.selectSubTextWave}
                    color="textPrimary"
                  >
                    ~
                  </CustomizedTypography>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <Select
                          displayEmpty
                          value={doNotDisturb?.to}
                          onChange={handleEndTimeChange}
                          MenuProps={{
                            classes: { paper: classes.menuPaper }
                          }}
                          className={classes.select}
                        >
                          <MenuItem value="" disabled>
                            종료 시간
                          </MenuItem>
                          {HourList(true)}
                        </Select>
                      </FormControl>
                      <CustomizedTypography
                        className={classes.selectSubText}
                        color="textPrimary"
                      >
                        까지 알림을 받지 않습니다.
                      </CustomizedTypography>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid container direction="column" spacing={1}>
                  <Grid item>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <CustomizedTypography
                        variant="body2"
                        color="textSecondary"
                      >
                        시작 시간
                      </CustomizedTypography>

                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <Select
                          displayEmpty
                          value={doNotDisturb?.from}
                          onChange={handleStartTimeChange}
                          MenuProps={{
                            classes: { paper: classes.menuPaper }
                          }}
                          className={classes.select}
                        >
                          <MenuItem value="" disabled>
                            시작 시간
                          </MenuItem>
                          {HourList(false)}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <CustomizedTypography
                        variant="body2"
                        color="textSecondary"
                      >
                        종료 시간
                      </CustomizedTypography>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <Select
                          displayEmpty
                          value={doNotDisturb?.to}
                          onChange={handleEndTimeChange}
                          MenuProps={{
                            classes: { paper: classes.menuPaper }
                          }}
                          className={classes.select}
                        >
                          <MenuItem value="" disabled>
                            종료 시간
                          </MenuItem>
                          {HourList(true)}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Collapse>
        </Box>
      </Grid>
      {matches && <Divider className={classes.boxDivider} />}
      <Grid item>
        <Box className={classes.box}>
          <Box className={classes.titleBox}>
            <Grid container direction="row" alignItems="center">
              <CustomizedTypography color="textSecondary">
                <img src={ResultNew} width={21} height={21} alt="ResultNew" />
              </CustomizedTypography>
              <CustomizedTypography className={classes.boxMainTitle}>
                프로젝트 알림
              </CustomizedTypography>
            </Grid>
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              className={classes.boxSubTitle}
            >
              견적서 도착, 파트너 회사소개서 도착, 파트너의 발주 거절 등 거래
              관련 알림을 받습니다.
            </CustomizedTypography>
            <Grid className={classes.warningBox}>
              <Grid item>
                <CustomizedTypography color="error">
                  <WarningFilled />
                </CustomizedTypography>
              </Grid>
              <Grid item>
                <CustomizedTypography variant="caption" color="error">
                  프로젝트 알림은 고객의 요청사항에 대한 중요한 알림입니다. 알림
                  해제 시 고객 대응이 늦어지는 등의 진행에 차질이 있을 수 있으니
                  유의해주세요.
                </CustomizedTypography>
              </Grid>
            </Grid>
          </Box>
          <Divider className={classes.titleDivider} />
          {/* <Box p={3}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <CustomizedTypography
                  className={classes.boxSubTitle}
                  color="textSecondary"
                >
                  알림 유형
                </CustomizedTypography>
              </Grid>
              {projectServices.map((service, index) => {
                const projectFilter = projectFilters?.filter(
                  (item) => item.service === service
                )[0];

                const { sms, email } = projectFilter;
                const checked = sms || email;

                return (
                  <Grid item key={index}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <CustomizedTypography
                          className={classes.notificationTypeTitle}
                          color="textPrimary"
                        >
                          {ProjectFiltersTitle[service]}
                        </CustomizedTypography>
                      </Grid>
                      <Grid item>
                        <Grid container direction="row" alignItems="center">
                          <CustomizedTypography
                            color="textSecondary"
                            className={clsx(classes.switchStateTitle, {
                              on: !!checked
                            })}
                          >
                            {checked ? '켜짐' : '꺼짐'}
                          </CustomizedTypography>
                          <Switch
                            color="primary"
                            checked={!!checked}
                            onChange={(e) => {
                              let data = setProjectByService(
                                service,
                                e.target.checked
                              );

                              const arr: Array<DataSet> = [
                                {
                                  kind: 'projectFilters',
                                  data
                                },
                                {
                                  kind: 'projectEmail',
                                  data: data.some((item) => item.email)
                                },
                                {
                                  kind: 'projectSMS',
                                  data: data.some((item) => item.sms)
                                }
                              ];

                              if (arr) {
                                onSubmitHandleAsArray(arr);
                              }
                            }}
                          ></Switch>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
          <Divider className={classes.titleDivider} /> */}
          <Box p={3}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <CustomizedTypography variant="body2" color="textPrimary">
                  알림 받을 채널
                </CustomizedTypography>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      카카오톡
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      카카오톡 수신이 불가한 경우 문자로 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: projectSmsChecked ?? false
                        })}
                      >
                        {projectSmsChecked ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={projectSmsChecked}
                        className={clsx(classes.switch, {
                          off: !projectSmsChecked
                        })}
                        onChange={(e) => {
                          const arr: Array<DataSet> = [
                            {
                              kind: 'projectFilters',
                              data: setProjectByChannel('SMS', e.target.checked)
                            },
                            {
                              kind: 'projectSMS',
                              data: e.target.checked
                            }
                          ];

                          if (arr) {
                            onSubmitHandleAsArray(arr);
                          }
                        }}
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      이메일
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      계정 이메일로 알림을 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: !!projectEmailChecked
                        })}
                      >
                        {projectEmailChecked ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={projectEmailChecked}
                        className={clsx(classes.switch, {
                          off: !projectEmailChecked
                        })}
                        onChange={(e) => {
                          const arr: Array<DataSet> = [
                            {
                              kind: 'projectFilters',
                              data: setProjectByChannel(
                                'Email',
                                e.target.checked
                              )
                            },
                            {
                              kind: 'projectEmail',
                              data: e.target.checked
                            }
                          ];

                          if (arr) {
                            onSubmitHandleAsArray(arr);
                          }
                        }}
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
      {matches && <Divider className={classes.boxDivider} />}
      <Grid item>
        <Box className={classes.box}>
          <Box p={3}>
            <Grid container direction="row" alignItems="center">
              <Chat size={21} />
              <CustomizedTypography className={classes.boxMainTitle}>
                채팅 알림
              </CustomizedTypography>
            </Grid>
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              className={classes.boxSubTitle}
            >
              파트너와의 채팅 수신 알림을 받습니다.
            </CustomizedTypography>
          </Box>
          <Divider className={classes.titleDivider} />
          <Box p={3}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <CustomizedTypography variant="body2" color="textPrimary">
                  알림 받을 채널
                </CustomizedTypography>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      카카오톡
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      카카오톡 수신이 불가한 경우 문자로 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: !!chatSMS
                        })}
                      >
                        {chatSMS ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={!!chatSMS}
                        onChange={(e) =>
                          onSubmitHandle('chatSMS', e.target.checked)
                        }
                        className={clsx(classes.switch, {
                          off: !chatSMS
                        })}
                        name="chattingKakaotalk"
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      이메일
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      계정 이메일로 알림을 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: !!chatEmail
                        })}
                      >
                        {chatEmail ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={!!chatEmail}
                        onChange={(e) =>
                          onSubmitHandle('chatEmail', e.target.checked)
                        }
                        className={clsx(classes.switch, {
                          off: !chatEmail
                        })}
                        name="chattingEmail"
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
      {matches && <Divider className={classes.boxDivider} />}
      <Grid item>
        <Box className={classes.box}>
          <Box p={3}>
            <Grid container direction="row" alignItems="center">
              <CustomizedTypography color="textPrimary">
                <Bullhorn size={21} />
              </CustomizedTypography>
              <CustomizedTypography className={classes.boxMainTitle}>
                캐파 소식 및 혜택
              </CustomizedTypography>
            </Grid>
            <CustomizedTypography
              variant="body2"
              color="textSecondary"
              className={classes.boxSubTitle}
            >
              캐파의 새로운 소식과 혜택에 관한 알림을 받습니다.
            </CustomizedTypography>
          </Box>
          <Divider className={classes.titleDivider} />
          <Box p={3}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <CustomizedTypography
                  className={classes.boxSubTitle}
                  variant="body2"
                  color="textPrimary"
                >
                  알림 받을 채널
                </CustomizedTypography>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      카카오톡
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      카카오톡 수신이 불가한 경우 문자로 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: !!newsSMS
                        })}
                      >
                        {newsSMS ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={!!newsSMS}
                        onChange={(e) =>
                          onSubmitHandle('newsSMS', e.target.checked)
                        }
                        className={clsx(classes.switch, {
                          off: !newsSMS
                        })}
                        name="capaInfoKakaotalk"
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item>
                    <CustomizedTypography variant="body1" color="textPrimary">
                      이메일
                    </CustomizedTypography>
                    <CustomizedTypography variant="body2" color="textSecondary">
                      계정 이메일로 알림을 발송합니다.
                    </CustomizedTypography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="row" alignItems="center">
                      <CustomizedTypography
                        className={clsx(classes.switchStateTitle, {
                          on: !!newsEmail
                        })}
                      >
                        {newsEmail ? '켜짐' : '꺼짐'}
                      </CustomizedTypography>
                      <Switch
                        color="primary"
                        checked={!!newsEmail}
                        onChange={(e) =>
                          onSubmitHandle('newsEmail', e.target.checked)
                        }
                        className={clsx(classes.switch, {
                          off: !newsEmail
                        })}
                        name="capaInfoEmail"
                      ></Switch>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {matches && <Box height={56} />}
      </Grid>
    </Grid>
  );
}
